import { useMatchDevice } from '@iziwork/design-system';
import { useMemo } from 'react';

export const useIsMobileOrTablet = () => {
  const isMobile = useMatchDevice('mobile');
  const isTablet = useMatchDevice('tablet');
  return useMemo(() => isMobile || isTablet, [isMobile, isTablet]);
};
